export interface FromDateRange {
  end: string;
  start: string;
}

export function getFromDateRange(
  fromDates: Iterable<string>,
): FromDateRange | null {
  const sortedFromDates = [...fromDates].toSorted(); // No need for dayjs due to ISO format
  const start = sortedFromDates.at(0);
  const end = sortedFromDates.at(-1);

  if (start === undefined || end === undefined) {
    return null;
  }

  return { start, end };
}
